import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { ReducerActionRotaSP } from 'store/modules/types';
import { PATH_SGU_API } from '../../../../../../../services/rotasp/path';

// TYPES
import { Types, CadastrarPerfilRequest } from './types';

// ACTIONS
import { cadastrarPerfilSuccess, cadastrarPerfilFailure } from './action';

function* cadastrarPerfil(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: CadastrarPerfilRequest } = request;

	const body = { ...payload };

	delete body.idUsuarioAutenticado;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_SGU_API,
		`perfis`,
		body,
		{ idUsuarioAutenticado: payload.idUsuarioAutenticado },
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastrarPerfilSuccess(response));
	} else {
		yield put(cadastrarPerfilFailure());
	}
}

export default all([takeLatest(Types.CADASTRAR_PERFIL, cadastrarPerfil)]);
